import { Component } from '@angular/core';
import { EdiOrderCardListComponent } from 'gung-standard';

@Component({
  selector: 'otto-olsen-edi-order-card-list',
  templateUrl: './otto-olsen-edi-order-card-list.component.html',
  styleUrl: './otto-olsen-edi-order-card-list.component.scss',
  standalone: false
})
export class OttoOlsenEdiOrderCardListComponent extends EdiOrderCardListComponent {}
